<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "MANAGER.TITLE" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="center p-24 pb-56">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="h1 pr-16">Supervisores</div>
            </div>

            <div class="content p-24" fusePerfectScrollbar>
                <app-tabla-supervisores
                    *ngIf="listaSupervisores"
                    [lista]="listaSupervisores"
                    [superSupervisor]="superSupervisor"
                    (guardarEvent)="guardarSupervisor($event)"
                    (borrarEvent)="deleteSupervisor($event)"
                >
                </app-tabla-supervisores>
            </div>
        </div>

        <button
            *ngIf="_menuUsuarioSrvc.esSupervisor() && superSupervisor"
            mat-fab
            class="accent"
            id="agregar-supervisor-button"
            (click)="nuevo()"
            aria-label="Nuevo cliente"
            [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
        >
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <!-- / CONTENT -->
</div>
